import { useQuery } from '@tanstack/react-query';
import type { AgentApiOrganizationTutorialsIndex } from '@/types/serializers';

export default function useFetchOrganizationTutorials() {
  return useQuery({
    queryKey: ['organization_tutorials'],
    queryFn: async () => {
      const response = await fetch('/agent/api/organization_tutorials');
      if (!response.ok) {
        // リダイレクトではなくエラーを投げる
        throw new Error(`API error: ${response.status}`);
      }
      const data: AgentApiOrganizationTutorialsIndex = await response.json();
      return data;
    },
    // エラー時は再試行せず、エラー状態を保持
    retry: false,
  });
}
